/**
 * @fileoverview `useMarketingShellTranslate(t)` — the translator for the words marketing-shell
 * itself renders (LIFE-SHORTLISTED-001 F-Q7-1).
 * @package @puffin-core/marketing-shell
 *
 * Resolution order: the consumer's `t` (honoured first) → the `marketingShell` namespace on the
 * instance in the React tree → `MARKETING_SHELL_EN`, so an unwired tree (the blog's server render)
 * renders readable English, never a raw key.
 *
 * `braces: 'single'` + `onMissing: 'keep'`: a placeholder whose param did not arrive is echoed back
 * (`{owner}`), so a missing param stays VISIBLE rather than blanking the sentence.
 *
 * ⚠️ Hook-placement rule (RECIPE §3): call this immediately above the first hook or expression that
 * consumes the translator.
 *
 * @module @puffin-core/marketing-shell/hooks/useMarketingShellTranslate
 */

import { createInterpolator } from '@puffin-core/i18n-bootstrap/strings-kit';
import { createNamespaceTranslate } from '@puffin-core/i18n-bootstrap/namespace-translate';

import { MARKETING_SHELL_NAMESPACE } from '../strings/namespace.js';
import { resolveString } from '../strings/resolveString.js';

export const useMarketingShellTranslate = createNamespaceTranslate({
  namespace: MARKETING_SHELL_NAMESPACE,
  resolveString,
  interpolate: createInterpolator({ braces: 'single', onMissing: 'keep' }),
});
